module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAIAAAC0Ujn1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QkbBhgBalUEFQAAADlJREFUSMdj/P//PwNtABMDzcCo0fQzmgVTiJGRkQyDMFPaaFiPGj1q9KjRo0aPeKMZR9sho0bjBQBJjgk3Dc7cIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/13.png
// module id = 768
// module chunks = 0